// dwaar/src/lib/praveshClient.js
// Repo: terralekha-core | Folder: dwaar/src/lib/
// Dwaar — thin fetch wrapper for the Pravesh FastAPI backend.
//
// Contracts (see api/pravesh/router.py):
//   POST /api/auth/magic-link     { email }          -> 200 { message }         (always 200)
//   POST /api/auth/otp/send       { mobile }         -> 200 { message }         (always 200)
//   POST /api/auth/otp/verify     { mobile, otp }    -> 200 { message, action_link }
//                                                       422 wrong/expired OTP
//                                                       500 upstream error
// Reveal doctrine: surface network/non-200 failures as thrown errors; the
// caller catches and shows the single generic PUBLIC_ERROR string.

const DEFAULT_BASE = "https://terralekha-core.onrender.com";

function apiBase() {
  const base = import.meta.env?.VITE_API_URL || DEFAULT_BASE;
  return base.replace(/\/+$/, "");
}

export async function requestMagicLink(email, { fetchImpl = fetch, baseUrl } = {}) {
  const url = `${baseUrl ?? apiBase()}/api/auth/magic-link`;
  const resp = await fetchImpl(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ email }),
  });

  if (!resp.ok) {
    // Don't leak server detail to the user — reveal doctrine.
    throw new Error("magic_link_dispatch_failed");
  }

  // Server always returns { message: "..." } on success; tolerate empty body.
  try {
    return await resp.json();
  } catch {
    return { message: "" };
  }
}


// ---------------------------------------------------------------------------
// sendOtp — POST /api/auth/otp/send
// ---------------------------------------------------------------------------

export async function sendOtp(mobile, { fetchImpl = fetch, baseUrl } = {}) {
  const url = `${baseUrl ?? apiBase()}/api/auth/otp/send`;
  const resp = await fetchImpl(url, {
    method:  "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body:    JSON.stringify({ mobile }),
  });

  if (!resp.ok) {
    throw new Error("otp_send_failed");
  }

  // Server always returns { message: "..." } on success.
  try {
    return await resp.json();
  } catch {
    return { message: "" };
  }
}


// ---------------------------------------------------------------------------
// verifyOtp — POST /api/auth/otp/verify
// Returns { message, action_link } on success.
// Throws on 422 (wrong OTP) or 500 (upstream error).
// ---------------------------------------------------------------------------

export async function verifyOtp(mobile, otp, { fetchImpl = fetch, baseUrl } = {}) {
  const url = `${baseUrl ?? apiBase()}/api/auth/otp/verify`;
  const resp = await fetchImpl(url, {
    method:  "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body:    JSON.stringify({ mobile, otp }),
  });

  if (!resp.ok) {
    // Don't leak server error detail to the user — reveal doctrine.
    throw new Error("otp_verify_failed");
  }

  return await resp.json();  // { message, action_link }
}
